import { Injectable } from '@angular/core';
import {
  AddOwnerCommand,
  IAddOwnerCommandParameters,
} from './command/addOwner.command';
import { IdentityService } from '../authentication/identity.service';
import { GetOwnerCommand } from './command/getOwner.command';
import { SaveOwnerCommand } from './command/saveOwner.command';
import {
  FindByDescriptionVehicleOwnersCommand,
  IFindByDescriptionVehicleOwnersParameters,
} from './command/find-by-description.command';
import { SortEnum } from '../enum/sortEnum.enum';
import {
  AddCheckingAccountMovementCommand,
  MovementForEnum,
} from '../driver/command/addCheckingAccountMovement.command';
import { DriverPlaceResponse } from '../models/responses/driver-last-place.response';
import { GetDriversCheckingAccountMovementsCommand } from '../driver/command/getDriversCheckingAccountMovements.command';
import { GetOwnerCheckingAccountMovementsCommand } from './command/getOwnerCheckingAccountMovements.command';
import { TranslateService } from '@ngx-translate/core';
import { ResendEmailConfirmationCommand } from './command/resendEmailConfirmation.command';
import { GetOwnerTravelsCurrentStatusCommand, IGetOwnerTravelCurrentStatusCommandParameters } from '../carrier/command/getOwnerTravelCurrentStatus.command';
import { GetOwnerBasicInfoCommand } from './command/getOwnerBasicInfo.command';
import { StorageKeyEnum } from '../storage/storageKeyEnum.enum';
import { SessionService } from '../session/session.service';
import { GetDriversCommand } from './command/getDrivers.command';
import { GetVehiclesCommand } from './command/getVehicles.command';
import { GetUnlinkedToDriverCommand } from './command/getUnlinkedToDriver.command';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { CreditDebitNoteRequestDTO, OwnerCheckingAccountMovementsResponseDTO, OwnerRequestDTO, OwnerResponseDTO, TravelsCurrentStatus } from '../authentication/connection/interfaces/apiInterfaces';
import { catchError, map, Observable, throwError } from 'rxjs';
import { GetOwnersPaginatedCommand, IGetOwnersPaginatedCommandParameters } from './command/getOwnersPaginated.command';

@Injectable()
export class OwnerService {
  constructor(
    private _connectionService: ConnectionServices,
    //private _notificationsService: NotificationsService,
    private _identityService: IdentityService,
    private _translateService: TranslateService,
    private _sessionService: SessionService
  ) { }

  public addOwner(owner: OwnerRequestDTO): Observable<boolean> {
    let addCommand = new AddOwnerCommand();

    addCommand.setParameters(owner);

    return this._connectionService
      .Request(addCommand)
      .pipe(
        map((data) => {
          /*
          this._notificationsService.showSuccessMessage(
            'toast.owner.title',
            'toast.shared.message.successful_message_add'
          );
          */
          return true;
        }),
        catchError((error) => {
          /*
          if (error.status === 409) {
            if (
              [
                'DOCUMENT_NOT_FOUND',
                'DOCUMENT_FIELD_NOT_FOUND',
                'DOCUMENT_FIELD_VALUE_UNIQUE',
                'INVALID_EXPIRATION_DATE',
              ].includes(error.error.errorCode)
            ) {
              if (error.error.errorCode === 'DOCUMENT_FIELD_VALUE_UNIQUE') {
                let document: string = error.error.description.split('|')[0];
                let field: string = error.error.description.split('|')[1];
                let document_field: string =
                  this._translateService.instant(
                    'carrier.documentation.types.' + document
                  ) +
                  ' - ' +
                  this._translateService.instant(
                    'carrier.documentation.field_types.' + field
                  );
                let errorDesc: string = this._translateService.instant(
                  'carrier.documentation.server_errors.document_field_value_unique'
                );
                this._notificationsService.showInternalErrorMessage(
                  'carrier.vehicles.title',
                  document_field + ': ' + errorDesc
                );
              } else {
                this._notificationsService.showInternalErrorMessage(
                  'carrier.vehicles.title',
                  'carrier.documentation.server_errors.' +
                  error.error.errorCode.toLowerCase()
                );
              }
            } else {
              if (error.error.errorCode === 'CUIL_UNIQUE') {
                this._notificationsService.showInternalErrorMessage(
                  'toast.owner.title',
                  'toast.users.error_code.identification_unique'
                );
                return throwError(error);
              } else if (error.error.errorCode === 'MAIL_UNIQUE') {
                this._notificationsService.showInternalErrorMessage(
                  'toast.owner.title',
                  'toast.users.error_code.mail_unique'
                );
                return throwError(error);
              }
            }
          }
          this._notificationsService.showHttpErrorMessage(
            'toast.owner.title',
            error
          );
          */
          return throwError(error);
        })
      )
  }

  public saveOwner(owner: OwnerRequestDTO): Observable<boolean> {
    let addCommand = new SaveOwnerCommand();

    addCommand.setParameters(owner);

    return this._connectionService
      .Request(addCommand)
      .pipe(
        map((data) => {
          /*
          this._notificationsService.showSuccessMessage(
            'toast.owner.title',
            'toast.shared.message.successful_message_modify'
          );
          */
          return true;
        }),
        catchError((error) => {
          let title;
          let message;
          /*
          if (
            [
              'DOCUMENT_NOT_FOUND',
              'DOCUMENT_FIELD_NOT_FOUND',
              'DOCUMENT_FIELD_VALUE_UNIQUE',
              'INVALID_EXPIRATION_DATE',
            ].includes(error.error.errorCode)
          ) {
            if (error.error.errorCode === 'DOCUMENT_FIELD_VALUE_UNIQUE') {
              let document: string = error.error.description.split('|')[0];
              let field: string = error.error.description.split('|')[1];
              let document_field: string =
                this._translateService.instant(
                  'carrier.documentation.types.' + document
                ) +
                ' - ' +
                this._translateService.instant(
                  'carrier.documentation.field_types.' + field
                );
              let errorDesc: string = this._translateService.instant(
                'carrier.documentation.server_errors.document_field_value_unique'
              );
              this._notificationsService.showInternalErrorMessage(
                'carrier.vehicles.title',
                document_field + ': ' + errorDesc
              );
            } else {
              this._notificationsService.showInternalErrorMessage(
                'carrier.vehicles.title',
                'carrier.documentation.server_errors.' +
                error.error.errorCode.toLowerCase()
              );
            }
          } else {
            if (error.error.errorCode === 'CUIL_UNIQUE') {
              this._notificationsService.showInternalErrorMessage(
                'toast.owner.title',
                'toast.users.error_code.identification_unique'
              );
            } else if (error.error.errorCode === 'TRAVELS_TO_SURRENDER') {
              this._notificationsService.showInternalErrorMessage(
                'toast.owner.title',
                'toast.vehicle.error_code.travels_to_surrender'
              );
            } else if (error.error.errorCode === 'VEHICLE_WITH_DRIVER_ASSIGNED') {
              this._notificationsService.showInternalErrorMessage(
                'toast.vehicle.title',
                'toast.vehicle.error_code.' + error.error.errorCode
              );
            } else if (
              error.error.errorCode === 'VEHICLE_OWNER_HAS_PENDING_SURRENDER'
            ) {
              this._notificationsService.showInternalErrorMessage(
                'toast.owner.title',
                'toast.owner.error_code.vehicle_owner_has_pending_surrender'
              );
            } else if (error.error.errorCode === 'MAIL_UNIQUE') {
              this._notificationsService.showInternalErrorMessage(
                'toast.owner.title',
                'toast.users.error_code.mail_unique'
              );
            } else {
              title = 'toast.owner.title';
              message = error;
            }
          }*/
          return throwError(error);
        })
      )
  }

  public getOwner(ownerid: string): Observable<OwnerResponseDTO> {
    let addCommand = new GetOwnerCommand();

    addCommand.setParameters({
      carrierId: this._identityService.userId,
      ownerId: ownerid,
    });

    return this._connectionService
      .Request(addCommand)
      .pipe(
        map((data) => {
          return data as any;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.owner.title',
            error
          );*/
          return throwError(error);
        })
      )
  }

  public getOwnersByDescription(term: string): Observable<any[]> {
    let addCommand = new FindByDescriptionVehicleOwnersCommand();
    addCommand.setParameters(<IFindByDescriptionVehicleOwnersParameters>{
      description: term,
      carrierUserId: this._identityService.userId,
    });
    return this._connectionService
      .Request(addCommand)
      .pipe(
        map((data) => {
          return data as any;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.owner.title',
            error
          );
          */
          return throwError(error);
        })
      )
  }



  getOwnerCheckingAccountMovements(
    ownerId: number,
    numberPage: number,
    rowsOnPage: number,
    sortField: string,
    sortOrder: SortEnum,
    startDate: any,
    endDate: any,
    find?: string,
    movementFilter?: string
  ): Observable<OwnerCheckingAccountMovementsResponseDTO> {
    const ownerCheckingAccountMovementsCommand =
      new GetOwnerCheckingAccountMovementsCommand();
    ownerCheckingAccountMovementsCommand.setParameters({
      id: ownerId,
      carrierUserId: this._identityService.userId,
      page: numberPage,
      size: rowsOnPage,
      column: sortField,
      sort: sortOrder,
      startDate: startDate,
      endDate: endDate,
      find: find,
      movementFilter: movementFilter
    });

    return this._connectionService
      .Request(ownerCheckingAccountMovementsCommand)
      .pipe(
        map((response) => {
          return response as any;
        }),
        catchError(error => {
          return throwError(false);
        })
      )
  }

  public getOwnersPaginated(
    carrierId: string,
    page: number,
    size: number,
    column: string,
    sort: string,
    find?: string
  ): Observable<any> {
    const command = new GetOwnersPaginatedCommand();
    command.setParameters(<IGetOwnersPaginatedCommandParameters>{
      carrierId,
      page,
      size,
      column,
      sort,
      find: find ?? '',
    });
    return this._connectionService.Request(command).pipe(
      map((data) => data as any),
      catchError((error) => throwError(() => error))
    );
  }

  resendEmailConfirmation(ownerId: number) {
    const resendEmailConfirmationCommand = new ResendEmailConfirmationCommand();
    resendEmailConfirmationCommand.setParameters({ ownerId: ownerId });

    return this._connectionService
      .Request(resendEmailConfirmationCommand)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return throwError(false);
        })
      )
  }

  public getTravelsCurrentStatus(): Observable<TravelsCurrentStatus> {
    const command = new GetOwnerTravelsCurrentStatusCommand();
    command.setParameters(<IGetOwnerTravelCurrentStatusCommandParameters>{
      carrierUserId: this._identityService.userId.toString(),
      ownerId: this._identityService.passengerId.toString()
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          console.error(error);
          return throwError(false);
        })
      )
  }

  public getOwnerBasicInfo(ownerid: string, userId?: string): Observable<OwnerResponseDTO> {
    let addCommand = new GetOwnerBasicInfoCommand();

    addCommand.setParameters({
      carrierId: this._identityService.userId,
      ownerId: ownerid,
      userId: userId
    });

    return this._connectionService
      .Request(addCommand)
      .pipe(
        map(data => {
          return data as any;
        }),
        catchError(error => {
          //this._notificationsService.showHttpErrorMessage('toast.owner.title', error);
          return throwError(error);
        })
      )
  }



  public saveCheckingAccountMovement(
    ownerId: number,
    note: CreditDebitNoteRequestDTO
  ): Observable<void> {
    const addCheckingAccountMovementCommand =
      new AddCheckingAccountMovementCommand();
    addCheckingAccountMovementCommand.setParameters({
      carrierUserId: Number(this._identityService.userId),
      id: ownerId,
      movementFor: MovementForEnum.OWNER,
      noteType: note.noteType,
      amount: note.amount,
      reason: note.reason,
      subUserId: this._sessionService.getItem(StorageKeyEnum.subUserId)
    });

    return this._connectionService
      .Request(addCheckingAccountMovementCommand)
      .pipe(
        map((response) => {
          /*
          this._notificationsService.showSuccessMessage(
            'toast.checking_accounts.movement',
            'toast.checking_accounts.message.movement_success'
          );
          */
          return response as any;
        }),
        catchError((error) => {
          return throwError(false);
        })
      )
  }

  public getDrivers(ownerId: string): Observable<any> {
    let command = new GetDriversCommand();

    command.setParameters({
      ownerId: ownerId,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.owner.title',
            error
          );
          */
          return throwError(error);
        })
      )
  }

  public getVehicles(ownerId: string): Observable<any> {
    let command = new GetVehiclesCommand();

    command.setParameters({
      ownerId: ownerId,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.owner.title',
            error
          );
          */
          return throwError(error);
        })
      )
  }

  public findUnlinkedToDriver(term: string): Observable<OwnerResponseDTO[]> {
    let addCommand = new GetUnlinkedToDriverCommand();

    addCommand.setParameters({
      carrierId: this._identityService.userId,
      find: term,
    });

    return this._connectionService
      .Request(addCommand)
      .pipe(
        map((data) => {
          return data as any;
        }),
        catchError((error) => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.owner.title',
            error
          );
          */
          return throwError(error);
        })
      )
  }

}
